<script>
import { $cloudinaryUrl } from '@/mixins/cloudinary'
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'image'
    },
    version: {
      type: Number
    },
    transformation: {
      type: String,
      required: true
    },
    alt: {
      type: String
    }
  },
  mixins: [$cloudinaryUrl],
  computed: {
    url () {
      return this.$cloudinaryUrl(this.type, this.id, this.transformation, this.version) // type, id, transformation, version)
    }
  }
}
</script>

<template>
  <img :src="url" :alt="this.alt || ''" />
</template>
